import React from 'react';
import { Property } from '../../../types';

interface Props {
  formData: Partial<Property>;
  onChange: (field: keyof Property, value: any) => void;
}

export const PropertyCommissionRatesBlock: React.FC<Props> = ({ formData, onChange }) => {
  const handleRateInput = (field: keyof Property, fallbackField: string, strVal: string) => {
    const val = strVal === '' ? null : (parseFloat(strVal) || 0) / 100;
    onChange(field, val);
    onChange(fallbackField as any, val);
  };

  const toPercent = (val: any) => (val != null ? Number((val * 100).toFixed(3)) : '');

  return (
    <div className="p-3 bg-sky-50 rounded-xl border border-sky-100">
      <h5 className="font-black text-sky-800 uppercase tracking-wider mb-2">Comisiones & Tasas Base</h5>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
        <div>
          <label className="font-bold text-gray-700 block mb-1">Comisión General (%)</label>
          <input
            type="number"
            step="0.001"
            value={formData.commissionRate ? toPercent(formData.commissionRate) : ''}
            onChange={(e) => onChange('commissionRate', (parseFloat(e.target.value) || 0) / 100)}
            className="w-full p-2 border rounded-lg bg-white"
            placeholder="Ej: 3"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Comisión Broker (%)</label>
          <input
            type="number"
            step="0.001"
            value={toPercent(formData.comision_override_broker ?? (formData as any).brokerCommissionRate)}
            onChange={(e) => handleRateInput('comision_override_broker', 'brokerCommissionRate', e.target.value)}
            className="w-full p-2 border rounded-lg bg-white"
            placeholder="Ej: 1.5"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Comisión Premium (%)</label>
          <input
            type="number"
            step="0.001"
            value={toPercent(formData.comision_override_premium ?? (formData as any).premiumCommissionRate)}
            onChange={(e) => handleRateInput('comision_override_premium', 'premiumCommissionRate', e.target.value)}
            className="w-full p-2 border rounded-lg bg-white"
            placeholder="Ej: 2.0"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Comisión Interna (%)</label>
          <input
            type="number"
            step="0.001"
            value={toPercent(formData.comision_override_interno ?? (formData as any).commissionInterno)}
            onChange={(e) => handleRateInput('comision_override_interno', 'commissionInterno', e.target.value)}
            className="w-full p-2 border rounded-lg bg-white"
            placeholder="Ej: 1.0"
          />
        </div>
      </div>
    </div>
  );
};
